import { render } from "./FinalizeSurveyOrder.vue?vue&type=template&id=64b32125"
import script from "./FinalizeSurveyOrder.vue?vue&type=script&lang=js"
export * from "./FinalizeSurveyOrder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__